<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3" v-if="loaded">
      <b-col lg="12">
        <b-card
          :title="
            'Gestion du groupe de destinataires : ' +
            bootstrap.nom +
            ' (' +
            bootstrap.total +
            ' destinataires)'
          "
          class="bg-light shadow"
          title-tag="h6"
        >
          <b-row>
            <b-col lg="6">
              <b-card
                class="bg-light shadow"
                title-tag="h6"
                title="Destinataires"
              >
                <div id="list-mails" v-html="bootstrap.mails"></div>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card
                class="bg-light shadow"
                title-tag="h6"
                title="Ajouter des addresses librement"
              >
                <label>Une adresse par ligne</label>
                <b-textarea v-model="free_mails" rows="6"></b-textarea>
                <b-button
                  @click="addFreeMails"
                  :disabled="free_mails.length == 0"
                  class="mt-2"
                  variant="success"
                  size="sm"
                  >Confirmer</b-button
                >
              </b-card>
              <b-card
                class="bg-light shadow mt-2"
                title-tag="h6"
                title="Importer d'un fichier CSV"
              >
                <el-upload
                  class="upload-demo d-inline"
                  ref="upload"
                  action="string"
                  multiple
                  :show-file-list="false"
                  :before-upload="handleChange"
                  :http-request="uploadFiles"
                >
                  <b-button
                    @click="documentType = 'public'"
                    class="mb-3 mr-3"
                    size="sm"
                    ><b-icon-plus-circle-fill
                      class="mr-2"
                    ></b-icon-plus-circle-fill
                    >Importer</b-button
                  >
                </el-upload>
              </b-card>
            </b-col>
            
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import newsletters from "@/services/newsletters.js";
import { Upload } from "element-ui";
export default {
  name: "NewslettersGroupUsers",
  components: { [Upload.name]: Upload, },
  props: ["id"],
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Module d'envoi de mails massif",
          to: { name: "newsletters" },
        },
        {
          text: "Groupes de destinataires",
          to: { name: "newslettersGroups" },
        },
        {
          text: "Gestion du groupe",
          active: true,
        },
      ],
      bootstrap: {},
      free_mails: "",
      busy: false,
      loaded: false,
    };
  },
  created() {
    this.load();
    document.addEventListener("click", (e) => {
      if (e.target && e.target.id.substring(0, 5) == "mail-") {
        e.preventDefault();
        this.deleteMailFromGroup(
          this.$props.id,
          e.target.parentElement.previousSibling.previousSibling.innerText
        );
      }
    });
  },
  methods: {
    load() {
      this.busy = true;
      newsletters.group(this.$props.id).then((response) => {
        this.bootstrap = response.data.data;
        this.busy = false;
        this.loaded = true;
      });
    },
    addFreeMails() {
      this.busy = true;
      newsletters.add_mails(this.$props.id, this.free_mails).then(() => {
        this.free_mails = "";
        this.load();
      });
    },
    deleteMailFromGroup(groupId, mail) {
      this.busy = true;
      newsletters.delete_mail(groupId, mail).then(() => {
        this.load();
      });
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
     handleChange(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$bvToast.toast(
          "Fichier trop lourd! Veillez à ne pas dépasser 100M",
          {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 5000,
            solid: false,
          }
        );
        return false;
      }
    },
     uploadFiles(res) {
      const formData = new FormData();
      formData.append("file", res.file);
      this.busy = true;
      newsletters.add_csv_file(this.$props.id, formData).then(() => {
        this.busy = false;
        this.load();
      });
    },
  },
};
</script>
<style lang="scss">
#list-mails {
  height: 70vh;
  overflow-y: scroll;
}
</style>